import { css } from '@emotion/react';
import { Primary, Secondary, p2r } from '../../styles/fonts';
import { colors, breakpoints } from '../../styles';

const { darkGray, darkGreen, white } = colors;

const styles = css`
  .menu-btn {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 5;
    display: none;
    width: 100%;
    max-width: 64px;
    min-height: ${p2r(64)};
    cursor: pointer;
  }

  .bars {
    padding: ${p2r(16)} 16px;
  }

  .bars div:not(:last-of-type) {
    margin-bottom: ${p2r(9)};
  }

  .bar-first,
  .bar-second,
  .bar-third {
    max-width: 32px;
    min-height: ${p2r(2)};
    margin: ${p2r(6)} 0;
    background-color: ${darkGray};
    transition: 0.3s;
  }

  .bar-first--active {
    background-color: ${white};
    -webkit-transform: rotate(-45deg) translate(-9px, 6px);
    transform: rotate(-45deg) translate(-9px, 6px);
  }

  .bar-second--active {
    opacity: 0;
  }

  .bar-third--active {
    background-color: ${white};
    -webkit-transform: rotate(45deg) translate(-8px, -8px);
    transform: rotate(45deg) translate(-8px, -8px);
  }

  .mobile-menu {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 4;
    display: none;
    width: 100vw;
    overflow: auto;
    background-color: ${darkGreen};
  }

  .mobile-menu__content {
    padding: ${p2r(35)} 40px ${p2r(20)} 61px;
  }

  .mobile-menu__submenu,
  .article-link {
    display: flex;
    flex-direction: column;
    color: ${white};
    text-decoration: none;
  }

  .article-link {
    padding-top: ${p2r(46)};
    font: normal normal 500 ${p2r(24)} / ${p2r(32)} ${Secondary};

    &--active {
      text-decoration: underline;
    }
  }

  .mobile-menu__link-navigation {
    position: relative;
    left: 15px;
    padding-top: ${p2r(5)};
    font: normal normal 300 ${p2r(18)} / ${p2r(28)} ${Primary};
    color: ${colors.white};
    text-decoration: none;
    letter-spacing: 0;

    &--active {
      text-decoration: underline;
    }
  }

  .mobile-menu__submenu-title {
    padding-top: ${p2r(16)};
    font: normal normal 300 ${p2r(18)} / ${p2r(28)} ${Primary};
  }

  .mobile-menu__link-navigation::before {
    position: absolute;
    left: -15px;
    content: ' - ';
  }

  .show {
    display: block;
  }

  .position-on-top {
    position: fixed;
  }

  @media (max-width: ${breakpoints.tablet}px) {
    .menu-btn {
      right: 16px;
    }
  }

  @media (max-width: ${breakpoints.tablet}px) {
    .menu-btn {
      display: block;
    }
  }

  @media (min-width: ${breakpoints.tablet + 1}px) {
    .mobile-menu {
      display: none;
    }
  }
`;

export default styles;
